import { Auth } from '@aws-amplify/auth';
import AsyncStorage from '@react-native-async-storage/async-storage';
import Moment from 'moment';
import signOut from './Signout';

const refreshToken = async (force = false) => {
  try {
    const currentSession = await Auth.currentSession();
    const sessionIdToken = currentSession.getIdToken();
    const { exp } = sessionIdToken.payload;

    // printing expiry time on every check so we can test this
    // eslint-disable-next-line no-console
    console.log(`JWT Expiry: ${Moment(exp * 1000).toLocaleString()}`);
    if ((exp - 60) < (Moment.now() / 1000) || force) {
      const cognitoUser = await Auth.currentAuthenticatedUser();
      const token = await currentSession.getRefreshToken();
      cognitoUser.refreshSession(token, (err, session) => {
        const { idToken } = session;
        // console.log(idToken.getJwtToken());
        AsyncStorage.setItem('token', idToken.getJwtToken());
      });
    } else {
      // console.log(sessionIdToken.getJwtToken());
      AsyncStorage.setItem('token', sessionIdToken.getJwtToken());
    }
  } catch {
    signOut();
  }
};

export default refreshToken;
